/* eslint-disable react/no-danger */
import validatePaidCampaign from '@helpers/validatePaidCampaign';
import Axios from 'axios';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import sanitizeHtml from 'sanitize-html';
import FooterComponent from '@/components/Footer/FooterComponent';
import Header from '@/components/Header/Header';
import PartnersModal from '@/components/PartnersPage/PartnersModal';
import PartnersPage from '@/components/PartnersPage/PartnersPage';
import { Hero, Jumbotron } from '@/components/PartnersPage/PartnersStyles';
import SEOHead from '@/components/SEOHead/SEOHead';
import { WordPressAPI } from '../config';
import dynamic from 'next/dynamic';

const FooterNewsModal = dynamic(import('@/components/FooterNewsModal'));

const Partners = ({ data }) => {
  const {
    content_header: contentHeader,
    form_disclaimer: formDisclaimer,
    form_title: formTitle,
    form_subtitle: formSubtitle,
    hero_background_image: heroBackgroundImage,
    hero_cta_button_text: ctaButtonText,
    hero_sub_title: heroSubtitle,
    hero_title: heroTitle,
    meta_description: metaDescription,
    meta_image: metaImage,
    the_partners: partners,
    additional_questions,
    phone_number_setup,
  } = data;

  const paid_campaign = validatePaidCampaign(data.paid_campaign);
  const activePartners = partners.filter(partner => partner.active);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleToggleModal = () => {
    setIsModalOpen(modal => !modal);
  };

  return (
    <>
      <SEOHead>
        <title>1-800Accountant Partners | 1-800Accountant</title>
        <meta key="description" name="description" content={metaDescription} />
        <meta property="og:image" content={metaImage} key="open-graph-image" />
        <script
          type="text/javascript"
          src="//app-ab33.marketo.com/js/forms2/js/forms2.min.js"
        />
      </SEOHead>
      <Header
        AdditionalQuestions={additional_questions}
        PaidCampaign={paid_campaign}
        phone_number={phone_number_setup}
      />
      <Jumbotron background={heroBackgroundImage.url}>
        <Hero>
          <div className="container">
            <div className="copy">
              <h1>{heroTitle}</h1>
              {/* eslint-disable-next-line react/no-danger */}
              <div
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(heroSubtitle, {
                    allowedTags: ['p'],
                    allowedAttributes: {
                      p: [''],
                    },
                  }),
                }}
              />
              <button type="button" className="btn btn-secondary" onClick={handleToggleModal}>
                {ctaButtonText}
              </button>
            </div>
            <PartnersModal
              form={{
                disclaimer: formDisclaimer,
                title: formTitle,
                subtitle: formSubtitle,
              }}
              handleToggleModal={handleToggleModal}
              isModalOpen={isModalOpen}
            />
          </div>
        </Hero>
      </Jumbotron>
      <PartnersPage partners={activePartners} contentHeader={contentHeader} />
      {/* Email Newsletter */}
      <FooterNewsModal />
      <FooterComponent phone_number={phone_number_setup} />
    </>
  );
};

export async function getStaticProps() {
  const { data } = await Axios.get(`${WordPressAPI.pages}/11129`);

  return {
    props: {
      data: data.acf,
    },
    // revalidate: 1,
  };
}

Partners.propTypes = {
  data: PropTypes.object,
};

export default Partners;
